/**
 * @generated SignedSource<<3c30630fc1795e27bb216386ee28d0c6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestartContentNodeAfterFailedInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation$variables = {
  input: RestartContentNodeAfterFailedInput;
};
export type useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation$data = {
  readonly LearnV2: {
    readonly restartContentNodeAfterFailed: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation = {
  response: useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation$data;
  variables: useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RestartContentNodeAfterFailedPayload",
        "kind": "LinkedField",
        "name": "restartContentNodeAfterFailed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c5d81bd75a678f1aa090a466576ed4c",
    "id": null,
    "metadata": {},
    "name": "useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation",
    "operationKind": "mutation",
    "text": "mutation useCardAdvanceContentNavigation_RestartContentNodeAfterNotYetPassedMutation(\n  $input: RestartContentNodeAfterFailedInput!\n) {\n  LearnV2 {\n    restartContentNodeAfterFailed(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3d9a7010fdfe3e5cf428d594327d443e";

export default node;
